/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';

const googlePlayLink = link => {
  return (<a href={ link } rel="me" target="_blank">
    <img className='footer__top__apps__app' src='/public/images/icons/ic_google_play.svg' />
  </a>);
};
const appStoreLink = <a href={ EnvironmentManager.getMessageText({ key: 'ios_footer_download_url' })  || 'https://app.adjust.com/kbqm4qx?engagement_type=fallback_click' } rel="me" target="_blank">
  <Icon className='footer__top__apps__app' iconName='svgIosAppStore' />
</a>;
const huaweiAppGalery = <a href="https://app.adjust.com/12cimxml?engagement_type=fallback_click&redirect=https%3A%2F%2Fappgallery.huawei.com%2F%23%2Fapp%2FC108310847" rel="me" target="_blank">
  <Icon className='footer__top__apps__app' iconName='svgHuaweiGallery' />
</a>;
const samsungGalaxyStore = <a href="https://app.adjust.com/12ema1ey?engagement_type=fallback_click&redirect=https%3A%2F%2Fgalaxystore.samsung.com%2Fdetail%2Fcom.bilyoner.app" rel="me" target="_blank">
  <Icon className='footer__top__apps__app' iconName='svgGalaxyStore' />
</a>;

const MarketingIcons = ({ device, platform }) => {
  const deviceVendor = device?.vendor?.toLowerCase();

  const android_download_link = EnvironmentManager.getMessageText({ key: 'footer_download_url' }) || 'https://app.adjust.com/11dirj6e?deep_link=bilyoner%3A%2F%2F';
  
  const renderButtons = () => {
    if (device?.type === 'mobile') {
      return platform?.toLowerCase() === 'android'
        ? <>
        { deviceVendor === 'huawei' && huaweiAppGalery }
        { deviceVendor === 'samsung' && samsungGalaxyStore }
        { googlePlayLink(android_download_link) }
        </>
        : appStoreLink;
    } else {
      return <>
      { googlePlayLink(android_download_link) }
      { appStoreLink }
      { huaweiAppGalery }
      { samsungGalaxyStore }
      </>;
    }
  };

  return (
    <div className="footer__top">
      <div className="footer__top__apps">{ renderButtons() }</div>
      <div className="footer__top__social">
        <a href="https://www.facebook.com/people/Bilyoner/100064472690953/" rel="me" target="_blank">
          <i className="bly bly-social-facebook bly-grey bly-size40" />
        </a>
        <a href="https://x.com/Bilyoner" rel="me" target="_blank">
          <i className="bly bly-social-twitter bly-grey bly-size40" />
        </a>
        <a href="https://www.instagram.com/bilyoner" rel="me" target="_blank">
          <i className="bly bly-social-instagram bly-grey bly-size40" />
        </a>
        <a href="http://www.youtube.com/BilyonerVideo" rel="me" target="_blank">
          <i className="bly bly-social-youtube bly-grey bly-size40" />
        </a>
      </div>
    </div>
  );
};

MarketingIcons.propTypes = {
  device: PropTypes.object,
  platform: PropTypes.string
};

export default MarketingIcons;
